import React, { Component } from "react";
import { Form, Button, Container, Col } from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../utils.js";
// Contexto
import { levelTeams } from "../../contexto";
export default class AñadirGrupoTrabajo extends Component {
  constructor(props) {
    super(props);

    this.postGrupoTrabajo = this.postGrupoTrabajo.bind(this);
  }

  // Función que hace el put a los datos del grupo de trabajo
  async postGrupoTrabajo(event) {
    event.preventDefault();
    let $this = $(this);
    //Formdata coge todo los elementos del formulario
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);
    let response1 = null;
    let id_provincia = this.props.path === "/direccionGeneral/gruposTrabajo/add" ? "14" : this.props.computedMatch.params.id_p;

    let settings = {
      url: process.env.REACT_APP_API_URL + "/provincias/" + id_provincia + "/gruposTrabajo",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    await $.ajax(settings)
      .done(async function (response) {
        response1 = JSON.parse(response);
      })
      .fail($this[0].props.ErrorHandling);

    // Hacemos el post a finalidad
    let myform2 = document.getElementById("MyFormCheck");
    let form2 = new FormData(myform2);
    let propositoRemove = ["Escolar", "Economía", "PJVT", "Formación", "Social", "Espiritualidad", "Salud", "MTA", "Pastoral", "Enfermerías", "Familia Teresiana", "Comunicación", "Servicios eclesiales", "Otro"];
    let propositoAdd = [];

    let indice = 0;
    // Creamos el json en funcion de esto y lo enviamos
    if (this.props.path === "/direccionGeneral/gruposTrabajo/add") {
      for (let pair of form2.entries()) {
        propositoAdd.push(pair[1]);
      }
    } else {
      for (let pair of form2.entries()) {
        indice = propositoRemove.indexOf(pair[0]);
        if (indice !== -1) {
          propositoAdd.push(pair[0]);
          propositoRemove.splice(indice, 1);
        }
      }
    }

    let obj = {
      propositoRemove,
      propositoAdd,
    };

    let settings2 = {
      url: process.env.REACT_APP_API_URL + "/provincias/" + id_provincia + "/gruposTrabajo/" + response1.id + "/propositos",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: "application/json",
      data: JSON.stringify(obj),
    };

    await $.ajax(settings2)
      .done(async function (response) {
        // TODO cambia si es en direccion general
        if ($this[0].props.path === "/direccionGeneral/gruposTrabajo/add") {
          $this[0].props.history.push({
            pathname: "/direccionGeneral/gruposTrabajo/" + response1.id,
          });
        } else {
          $this[0].props.history.push({
            pathname: "/provincias/" + id_provincia + "/gruposTrabajo/" + response1.id,
          });
        }
        $this[0].props.setAlert("", "Se ha añadido correctamente el equipo/comisión", "success");
      })

      .fail($this[0].props.ErrorHandling);
  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();

    return (
      <Container className="my-5 border">
        <Form className=" p-4" onSubmit={this.postGrupoTrabajo} id="MyForm" autoComplete="off">
          <Form.Group>
            <Form.Row>
              <small className="mb-3">
                Los campos con un <b>*</b> deben de ser rellenados.
              </small>
            </Form.Row>
          </Form.Group>
          <Form.Row>
            <Form.Group as={Col} xl="4">
              <Form.Label>Nombre Equipo/Comisión *</Form.Label>
              <Form.Control required type="text" name="name" maxLength="90" autoComplete="nope" />
            </Form.Group>
            <Form.Group as={Col} xl="4">
              <Form.Label>Fecha de Creación *</Form.Label>
              <Form.Control required type="date" name="creationDate" max={today} autoComplete="nope" />
            </Form.Group>
            <Form.Group as={Col} xl="4">
              <Form.Label>Fecha de Cierre</Form.Label>
              <Form.Control type="date" name="endDate" max={today} autoComplete="nope" />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} xl="4">
              <Form.Label>Email *</Form.Label>
              <Form.Control required type="email" name="email" autoComplete="nope" />
            </Form.Group>
            <Form.Group as={Col} xl="4">
              <Form.Label>Tipo *</Form.Label>
              <Form.Control required autoComplete="nope" as="select" name="type">
                <option>Equipo</option>
                <option>Comisión</option>
              </Form.Control>
            </Form.Group>
            {this.props.path === "/direccionGeneral/gruposTrabajo/add" && (
              <Form.Group as={Col} xl="4">
                <Form.Label>Nivel *</Form.Label>
                <Form.Control required autoComplete="nope" as="select" name="level">
                  {levelTeams.map((level) => (
                    <option value={level} key={level}>
                      {level}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            )}
          </Form.Row>
          <Form id="MyFormCheck" className="my-3">
            <Form.Label>Finalidad del equipo</Form.Label>
            {this.props.path === "/direccionGeneral/gruposTrabajo/add" ?

              <Form.Control label="proposito" type="text" name="finalidad" maxLength="200" autoComplete="nope" />
              :
              <Form.Row>
                <Col lg="6">
                  <Form.Check label="Escolar" name="Escolar" />
                  <Form.Check label="Economía" name="Economía" />
                  <Form.Check label="PJVT" name="PJVT" />
                  <Form.Check label="Formación" name="Formación" />
                  <Form.Check label="Social" name="Social" />
                  <Form.Check label="Espiritualidad" name="Espiritualidad" />
                </Col>
                <Col lg="6">
                  <Form.Check label="Salud" name="Salud" />
                  <Form.Check label="MTA" name="MTA" />
                  <Form.Check label="Pastoral" name="Pastoral" />
                  <Form.Check label="Enfermerías" name="Enfermerías" />
                  <Form.Check label="Familia Teresiana" name="Familia Teresiana" />
                  <Form.Check label="Comunicación" name="Comunicación" />

                  <Form.Check label="Servicios eclesiales" name="Servicios eclesiales" />
                </Col>
                <Col lg="6">
                  <Form.Check label="Otro" name="Otro" />
                </Col>
              </Form.Row>
            }
          </Form>
          <Form.Group>
            <Form.Label>Fotografía <small>(máx. 500KB)</small></Form.Label>
            <Form.Control type="file" name="photo" />
          </Form.Group>
          <Form.Group>
            <Button type="submit" variant="outline-dark" className="btn btn-block mt-5" name="Datos Canonicos">
              Guardar
            </Button>
          </Form.Group>
        </Form>
      </Container>
    );
  }
}
